import LoginVerify from "../../../../jsx/pages/Agent/LoginVerify";

const LoginVerifyWrapper = function (props) {
  return <LoginVerify />;
};

export default constore(LoginVerifyWrapper);
